import { useMemo } from 'react';
import STAKEHOLDER_OPTIONS, {
  IStakeHolderOptions,
  StakeHolderId,
  UseEntityTypeProps,
  UseEntityTypeReturn,
} from '../constants/stakeHolderOptions';

const useEntityType = ({
  personType,
}: UseEntityTypeProps): UseEntityTypeReturn => {
  const isJuridicalMX = useMemo(
    () => personType === StakeHolderId.JURIDICAL_MX,
    [personType]
  );

  const isJuridicalFR = useMemo(
    () => personType === StakeHolderId.JURIDICAL_FR,
    [personType]
  );

  const isNaturalMX = useMemo(
    () => personType === StakeHolderId.NATURAL_MX,
    [personType]
  );

  const isNaturalFR = useMemo(
    () => personType === StakeHolderId.NATURAL_FR,
    [personType]
  );

  const isNaturalPerson = useMemo(
    () =>
      personType === StakeHolderId.NATURAL_FR ||
      personType === StakeHolderId.NATURAL_MX,
    [personType]
  );

  const isJuridicalPerson = useMemo(
    () =>
      personType === StakeHolderId.JURIDICAL_FR ||
      personType === StakeHolderId.JURIDICAL_MX,
    [personType]
  );

  const isForeign = useMemo(
    () =>
      personType === StakeHolderId.NATURAL_FR ||
      personType === StakeHolderId.JURIDICAL_FR,
    [personType]
  );

  const isMexicanPerson = useMemo(
    () =>
      personType === StakeHolderId.JURIDICAL_MX ||
      personType === StakeHolderId.NATURAL_MX,
    [personType]
  );

  const getEntityTypeSelectOption = (
    selectedOption: IStakeHolderOptions['value'] | IStakeHolderOptions['id']
  ): IStakeHolderOptions => {
    if (selectedOption) {
      const filteredValue = STAKEHOLDER_OPTIONS.find(
        (option) =>
          option.value === selectedOption || option.id === selectedOption
      );
      return filteredValue ?? STAKEHOLDER_OPTIONS[0];
    }
    return STAKEHOLDER_OPTIONS[0];
  };

  return {
    isJuridicalMX,
    isJuridicalFR,
    isNaturalMX,
    isNaturalFR,
    isNaturalPerson,
    isJuridicalPerson,
    isForeign,
    isMexicanPerson,
    getEntityTypeSelectOption,
  };
};

export default useEntityType;
